import React, { useState } from "react";
import "./AboutUsUser.css";
import { useTranslation } from "../../utils/hooks/translateHook";
import ContentHtml from "../../utils/contentHtml";
import { useLocation } from 'react-router-dom';
import { courseRegistry } from "../../courses/courseRegistry";

export default function AboutUs() {
  const t = useTranslation();
  const [activeCard, setActiveCard] = useState(null);
   const location = useLocation();
  let themeClass = "theme-global";
  
    Object.keys(courseRegistry).forEach((courseSlug) => {
      if (location.pathname.includes(courseSlug)) {
        themeClass = `theme-${courseSlug}`;
      }
    });

  const cards = [
    { id: "01", text: "about_card01_text", hover: "about_card01_hover", title: null },
    { id: "02", text: "about_card02_text", hover: "about_card02_text", title: "about_card02_title" },
    { id: "03", text: "about_card03_text", hover: "about_card03_hover", title: "about_card03_title" },
    { id: "04", text: "about_card04_text", hover: "about_card04_hover", title: "about_card04_title" },
  ];

  return (
    <div className={`about-wrapper ${themeClass}`}>
    <div className="about-user" >
      <section className="about-user-layout">
        {cards.map((card) => (
          <div
            key={card.id}
            className={`card card-${card.id} ${activeCard === card.id ? "active" : ""}`}
            onClick={() => setActiveCard(activeCard === card.id ? null : card.id)}
          >
            <div className={`about-card-header ${card.id !== "01" ? "bottom" : ""}`}>
              <span className="about-card-number">{card.id}</span>
              {card.title && <span className="card-title">{t(card.title)}</span>}
            </div>

            <div className="card-content">
              <ContentHtml className="about-user-card-text" html={t(card.text)} />
              {card.hover && (
                <ContentHtml className="card-hover-text" html={t(card.hover)} />
              )}
            </div>
          </div>
        ))}

        <h2 className="about-user-title">
          {t("about_title1")} <br />
          {t("about_title2")}
        </h2>
      </section>

      <section className="about-elemnt">
        <h2 className="about-e-title">{t("about_first")}</h2>
        <p className="about-e-text">{t("about_second")}</p>
      </section>
    </div>
    </div>
  );
}